import type { TypePolicies } from '@apollo/client';

/**
 * Type policies for After Effects UXP integration.
 */
export const typePolicies: TypePolicies = {
  Subscription: {
    fields: {
      exportRenderEvents: {
        merge: false,
      },
    },
  },
};
